import { cn } from "../lib/utils";
import { Icon } from "../primitives";

export const RequiredForApprovalIndicator = ({
	active,
	className,
}: {
	active: boolean;
	className?: string;
}) => (
	<Icon
		type="exclamation-circle"
		color={active ? "danger" : "tertiary"}
		size="micro"
		className={cn(active && "fill-surface-danger", className)}
	/>
);
